module.exports = __webpack_public_path__ + "img/link.72f96e25.svg";